// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"432":"5b2435e9","882":"12ce9499"}[chunkId] + ".chunk.css";
};